import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE = 'https://ayumisuzuki.com';

const RouteSeo = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const path = pathname.replace(/\/+$/, '');
    const url = `${SITE}${path}`;
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', url);
    document.querySelector('meta[property="og:url"]')?.setAttribute('content', url);
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }
    const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: 'smooth' }), 150);
    return () => clearTimeout(t);
  }, [pathname, hash]);

  return null;
};

export default RouteSeo;
